import { z } from 'zod';

export enum WorkerStatus {
  ONBOARDED = 'Onboarded',
  ONBOARDING = 'Onboarding',
  NOT_ONBOARDING = 'NotOnboarding',
}

const paymentObjectSchema = z.object({
  workerName: z.string(),
  paymentId: z.string(),
  creationDate: z.string(),
  invoiceNumber: z.string(),
  status: z.string(),
  dueDate: z.string(),
  invoiceUrl: z.string().nullish(),
});

export const paymentInfiniteResponseSchema = z.object({
  totalRows: z.number(),
  nextPage: z.number().optional(),
  previousPage: z.number().optional(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
  items: z.array(paymentObjectSchema),
});

const paymentUsersObjectSchema = z.object({
  flexWorkerId: z.string(),
  fullName: z.string(),
  iban: z.string().optional(),
  hasPendingBankAccount: z.boolean(),
  status: z.nativeEnum(WorkerStatus),
  isBlocked: z.boolean(),
});

export const paymentUsersInfiniteResponseSchema = z.object({
  totalRows: z.number(),
  nextPage: z.number().optional(),
  previousPage: z.number().optional(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
  items: z.array(paymentUsersObjectSchema),
});

export type PaymentInfiniteResponse = z.infer<typeof paymentInfiniteResponseSchema>;
export type PaymentUsersInfiniteResponse = z.infer<typeof paymentUsersInfiniteResponseSchema>;
